import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import SliderDemo from './SliderDemo'
import SliderElement from './SliderElement'
import SliderFormBrand from './SliderFormBrand'
import { STYLE_FORM_SCHEMA } from './SliderFormStyle'
import SliderFormValue from './SliderFormValue'
import sliderIcon from './assets/slider.svg'

export default genElementConfig(CONFIG_ELEMENTS.slider, {
  label: t('elements.slider.label'),
  icon: sliderIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: SliderElement,
  Demo: [SliderDemo],
  FormValue: SliderFormValue,
  FormBrand: SliderFormBrand,
  EditorActions: null,
})
